import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import "pages/Styles/ReferralsView.sass"
import { httpClient } from "../../funcs"
import notifyUser, { notifyAboutError } from "../../methods/notifyUser"
import Popup from "../../components/Popup"
import EnterTextPopup from "../Common/EnterTextPopup"

type Props = {
    close: Function,
    onCollectBonus: Function,
    $store: any,
    $commitToStore: Function
}

function bonusTitle(bonus: any): string {
    if (!bonus || !Array.isArray(bonus) || bonus.length < 2) {
        return ""
    }
    if (bonus[0] == "PromoCodeBonusType.PROLONG_SUBSCRIPTION") {
        return `Продление подписки на ${bonus[1]} дней`
    }
    if (bonus[0] == "PromoCodeBonusType.ADD_DOCUMENTS_COUNT") {
        return `+${bonus[1]} бонусных договоров на ваш счет`
    }
    return ""
}

function moneyBonusTitle(bonus: number): string {
    return `${bonus / 100} рублей на карту 🔥🔥🔥`
}

function moneyBonusButtonLabel(collected: any): string {
    if (!collected) return "Получить денежный бонус"
    if (collected === "AWAITING") return "Запрос на бонус отправлен"
    if (collected === "COLLECTED") return "Денежный бонус получен"
    return ""
}

let ReferralsView: any = function ReferralsView(props: Props) {

    const [referrals, setReferrals] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [referralToCollect, setReferralToCollect] = useState<any | null>(null)

    useEffect(() => {
        requestReferrals()
    }, [])

    function requestReferrals() {
        httpClient.get('/get-referrals').then(({ data }) => {
            setReferrals(data)
            setLoading(false)
        }).catch((error) => {
            notifyAboutError(props, error)
            setLoading(false)
        })
    }

    function collectBonus(referral: any) {
        setLoading(true)
        httpClient.post('/collect-referral-bonus', {
            promo_history_id: referral._id
        }).then(({ data }) => {
            requestReferrals()
            notifyUser(props, "Бонус активирован", data)
            props.onCollectBonus()
        }).catch((error) => {
            notifyAboutError(props, error)
        })
    }

    function collectMoneyBonus(referral: any, message: string) {
        setLoading(true)
        httpClient.post('/collect-referral-money-bonus', {
            promo_history_id: referral._id,
            message: message
        }).then(({ data }) => {
            requestReferrals()
            notifyUser(props, "Запрос отправлен", data)
            props.onCollectBonus()
        }).catch((error) => {
            notifyAboutError(props, error)
        })
    }

    if (referralToCollect) {
        return <EnterTextPopup
            title={"Введите номер и банк на который вам перевести бонус"}
            placeholder={"Номер телефона и банк"}
            oldText={''}
            onClose={() => {
                setReferralToCollect(null)
            }}
            canSaveEmpty={false}
            saveNewName={(message: string) => {
                collectMoneyBonus(referralToCollect, message)
                setReferralToCollect(null)
            }}
        />
    }

    return <Popup
        style={{ zIndex: 999 }}
        onClose={props.close}
    >
        <div className="referrals-popup-v2 ui-kit-v2">
            <h2 className="referrals-popup-v2__title Subheader_18">
                Список приведенных вами людей
            </h2>
            <p className="referrals-popup-v2__description Body_16_v2_secondary">
                Расскажите о сервисе ОкиДоки своим друзьям и поделитесь своим промо кодом. За каждого, кто купит пакет или оформит подписку, вы получите бонус!
            </p>
            <ul className="cells-list referrals-popup-v2__list">
                {referrals.map((referral: any, index: number) => {
                    const user = referral.user_activated
                    const key = referral._id ?? `ref-${index}`

                    if (!user) {
                        const fullname = referral.fullname
                        if (!fullname) {
                            return null
                        }
                        return (
                            <li key={key} className="cell-card ui-kit-v2">
                                <h3 className="cell-card-title">{referral.fullname}</h3>
                                <p className="cell-card-meta referrals-popup-v2__line">
                                    {referral.contracts_count
                                        ? `Покупок по вашему промо-коду нет. Выставил договоров: ${referral.contracts_count}.`
                                        : "Зарегистрировался, но пока еще не пользовался и ничего не купил"}
                                </p>
                            </li>
                        )
                    }

                    return (
                        <li key={key} className="cell-card ui-kit-v2">
                            <h3 className="cell-card-title">
                                {user.fullname || 'Имя не указано'}
                            </h3>
                            <p className="cell-card-meta referrals-popup-v2__line">
                                Купил {user.tariff?.type == 'package' ? 'пакет' : 'подписку'} {user.tariff?.name || 'неизвестно'} за {user.purchase_price ? (user.purchase_price / 100) : 0} рублей
                            </p>
                            <p className="Body_16_v2 referrals-popup-v2__bonus-label">
                                Ваш бонус: {bonusTitle(user.bonus)}
                            </p>
                            <div className="referrals-popup-v2__actions">
                                <button
                                    type="button"
                                    className="new ui-kit-v2-button action-button primary inline"
                                    disabled={(referral.bonus_collected ?? false) || loading}
                                    onClick={() => collectBonus(referral)}
                                >
                                    <span className="button-text">
                                        {(referral.bonus_collected ?? false) ? "Бонус получен" : "Получить бонус"}
                                    </span>
                                </button>
                            </div>
                            {!!user.money_bonus && (
                                <div className="referrals-popup-v2__money-block">
                                    <p className="Body_16_v2 referrals-popup-v2__money-text">
                                        Денежный бонус: {moneyBonusTitle(user.money_bonus)}
                                    </p>
                                    <div className="referrals-popup-v2__actions">
                                        <button
                                            type="button"
                                            className="new ui-kit-v2-button action-button primary inline"
                                            disabled={!!referral.money_bonus_collected || loading}
                                            onClick={() => setReferralToCollect(referral)}
                                        >
                                            <span className="button-text">
                                                {moneyBonusButtonLabel(referral.money_bonus_collected)}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </li>
                    )
                })}
            </ul>
        </div>
    </Popup>
}

ReferralsView = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(ReferralsView)

export default ReferralsView
